.sprintDate {
	text-align: center;
}
